import { render, staticRenderFns } from "./UserBadgeList.vue?vue&type=template&id=3f603728"
import script from "./UserBadgeList.vue?vue&type=script&lang=js"
export * from "./UserBadgeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports